var _path, _path2, _path3, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78866 18.2592L3.94031 14.9697C2.91426 13.0885 2.66515 10.882 3.24695 8.82816C3.82874 6.7743 5.19458 5.03847 7.04861 3.99668C8.90265 2.95488 11.0956 2.691 13.1524 3.2622C15.2092 3.8334 16.9643 5.19368 18.0375 7.0484L19.8859 10.3378",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3649 17.4502H1.24365V36.1083H27.3649V17.4502Z",
    fill: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6582 27.4012C17.4985 28.9951 15.9344 29.8889 14.3047 29.8889C12.6749 29.8889 11.1108 28.9951 9.9511 27.4012",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.70725,
    cy: 24.9134,
    r: 1.24387,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9021,
    cy: 24.9134,
    r: 1.24387,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.51cdf33f3310b890df93661ece4aaa57.svg";
export { ForwardRef as ReactComponent };